var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CountDown"},[_c('span',{staticClass:"_user-select"},[_vm._v(_vm._s(_vm.hour ? _vm.hourString + ':' + _vm.minuteString + ':' + _vm.secondString : _vm.minuteString + ':' + _vm.secondString))])])
}
var staticRenderFns = []

export { render, staticRenderFns }